import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=530d4719&scoped=true&"
import script from "./AddCampaign.vue?vue&type=script&lang=ts&"
export * from "./AddCampaign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d4719",
  null
  
)

export default component.exports